export default function Marquee({ items = [], reverse = false, speed = 60 }) {
  const track = [...items, ...items];
  return (
    <div className="overflow-hidden py-8 border-y border-[var(--line)]" data-testid="editorial-marquee">
      <div
        className="marquee-track whitespace-nowrap flex gap-16"
        style={{
          animationDuration: `${speed}s`,
          animationDirection: reverse ? "reverse" : "normal",
        }}
      >
        {track.map((t, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl lg:text-7xl text-[var(--ink)] tracking-tight"
          >
            <span className="opacity-40 mr-16">✦</span>
            {t}
          </span>
        ))}
      </div>
    </div>
  );
}
